module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/suits-270524ecda8e5177397f8964c73f3cbb.webp";